// Text and box traits: content, headers, hints, favorites and attributes.
import { addBoxTrait, addTextTrait, type CssMap } from "@/modules/styleCss";
import type { StyleTraits } from "@/types/experience";

export function loadTextTraits(
  target: string,
  css: CssMap,
  traits: StyleTraits,
) {
  if (traits.content) {
    addTextTrait(target, css, ".content", traits.content);
  }

  if (traits.contentStrong) {
    addTextTrait(target, css, ".content .strong", traits.contentStrong);
  }

  if (traits.contentEmphasized) {
    addTextTrait(target, css, ".content .emphasized", traits.contentEmphasized);
  }

  if (traits.contentLink) {
    addTextTrait(target, css, ".content .link, .content a", traits.contentLink);
  }

  if (traits.contentAlternate1) {
    addTextTrait(target, css, ".content-alt-1", traits.contentAlternate1);
  }

  if (traits.header1) {
    addTextTrait(target, css, ".header-1", traits.header1);
    addBoxTrait(target, css, ".header-1", traits.header1);
  }

  if (traits.header2) {
    addTextTrait(target, css, ".header-2", traits.header2);
    addBoxTrait(target, css, ".header-2", traits.header2);
  }

  if (traits.listHeader2) {
    addTextTrait(target, css, ".list-shop-window h2", traits.listHeader2);
    addBoxTrait(target, css, ".list-shop-window h2", traits.listHeader2);
  }

  if (traits.footnote) {
    addTextTrait(target, css, ".annotation .annotation-text", traits.footnote);
    addBoxTrait(target, css, ".annotation", traits.footnote);
    addTextTrait(target, css, ".favorite-annotation", traits.footnote);
    addBoxTrait(target, css, ".favorite-annotation", traits.footnote);
    addTextTrait(target, css, ".favorite-footnote", traits.footnote);
    addBoxTrait(target, css, ".favorite-footnote", traits.footnote);
  }

  if (traits.price) {
    addTextTrait(target, css, ".price", traits.price);
  }

  if (traits.hintDescription) {
    addBoxTrait(
      target,
      css,
      ".shop-window-hints-description",
      traits.hintDescription,
    );
  }

  if (traits.hintTitle) {
    addTextTrait(
      target,
      css,
      ".shop-window-hints-description .hint-title",
      traits.hintTitle,
      true,
    );
    addBoxTrait(
      target,
      css,
      ".shop-window-hints-description .hint-title",
      traits.hintTitle,
    );
  }

  if (traits.hintSubtitle) {
    addTextTrait(
      target,
      css,
      ".shop-window-hints-description .hint-subtitle",
      traits.hintSubtitle,
      true,
    );
    addBoxTrait(
      target,
      css,
      ".shop-window-hints-description .hint-subtitle",
      traits.hintSubtitle,
    );
  }

  if (traits.hintTap) {
    addTextTrait(target, css, ".hint-tap span", traits.hintTap);
    addBoxTrait(target, css, ".hint-tap", traits.hintTap);
  }

  if (traits.favoriteDetails) {
    addBoxTrait(
      target,
      css,
      ".favorite-details-scroller",
      traits.favoriteDetails,
    );
  }

  if (traits.favoriteDescription) {
    addTextTrait(
      target,
      css,
      ".favorite-description",
      traits.favoriteDescription,
    );
    addBoxTrait(
      target,
      css,
      ".favorite-description",
      traits.favoriteDescription,
    );
  }

  if (traits.attributeTitle) {
    addTextTrait(target, css, ".attribute .title", traits.attributeTitle);
  }

  if (traits.attributeValue) {
    addTextTrait(target, css, ".attribute .value", traits.attributeValue);
  }
}
